import React, { useContext, useMemo, useState } from 'react'
import MainLogo from "../images/login-logo.svg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { folderNameRegex } from "../helpers/RegexHelpers";

import "../scss/login.scss";
import Service from '../services';
import { RoutesEnum } from '../models/RoutesModel';
import { toast } from 'react-toastify';
import { ThemeContext } from '../models/ThemeContext';
import { ThemeTypes } from '../models/SharedModel';

type Props = {}
// Todo: remove from here
enum fieldType {
    TEXT = "text",
    PASSWORD = "password",
  }

  interface IInputValuesModel {
    username: string,
    password: string,
  }


const SignUp = (props: Props) => {

const service = new Service();

const [error, setError] = useState("");
const [errorField, setErrorField] = useState("");

const [inputValues, setInputValues] = useState<IInputValuesModel>({
    username: '',
    password: ''
  })

  const handleChange = (value: string, field: string) => {
    setError('')
    setInputValues(prev => ({ ...prev, [field]: value }))
  } 

  const validateUserName = (value: string) => {
    if (value?.match(folderNameRegex)) {
      setError('')
    } else setError('Only alphabets, 0-9, "_" are allowed for Username')
  }

  
  const signInDisabled = useMemo(() => {
    if (error) return true
    else return false
  }, [error, inputValues])

  const role = 'admin';
  const signInSubmit = () => {
    if (inputValues?.username?.length < 5) {
        setError('Username must have minumum 4 characters')
      } 
    else if (!error) {
        const data = {
            username:inputValues.username,
            // role_name:role,
        }
        service.add_user_details(data).then((response:any)=>{
          toast.success(response?.data)
            gotoLogin()
        }).catch((error:any)=>{
            console.log(error)
            toast.error("Something went wrong");
        })
        // alert(JSON.stringify(data))
      } 
  }

  const gotoLogin = () =>{
    window.location.href = `${RoutesEnum.LOGIN}`
  }

  const { themeName } = useContext(ThemeContext);

  return (
    <div className={`${themeName === ThemeTypes?.BLUE_THEME ? 'login-main-light' :'login-main-dark'}`}>
      <div className="login-form">
      <div className="main-logo">
        <img src={MainLogo} alt="MainLogo" className="logo-icon" />
        <div className="main-heading">No Account!</div>
        <div className="sub-heading">Please Sign Up here. </div>
        <div className="form-main">
        <div className="erorr-message">{error}</div>
        <p className={`input-box username ${errorField === fieldType.TEXT ? 'error' : ''}`}>
              <div className="icon"><FontAwesomeIcon icon={faUser} /></div>
              <input
                type="text"
                id="username"
                name="username"
                className="form-control"
                placeholder="Username"
                required={true}
                value={inputValues?.username || ''}
                onChange={e => {
                  handleChange(e?.target?.value, 'username')
                  validateUserName(e?.target?.value)
                }}
                onBlur={e => validateUserName(e?.target?.value)}
                onKeyDown={e => e.code === "Enter" && signInSubmit()}
              />
            </p>

            <button 
              className="sign-in-button" 
              type="submit"
              disabled={signInDisabled}
              onClick={signInSubmit}
            >
              Sign In
            </button>
        </div>
      </div>
      </div>
    </div>
  )
}

export default SignUp;